export function getQueryParam(
  needle: string,
  query: string = window.location.search
): string | Array<string> | undefined {
  return parseQueryString(query)[needle]
}

export function queryParamHas(
  param: string,
  value: string,
  query: string = window.location.search
): boolean {
  const queryValue = parseQueryString(query)[param]
  const queryValuesArray = Array.isArray(queryValue) ? queryValue : [queryValue]

  return queryValuesArray.indexOf(value) !== -1
}

export function parseQueryString(query: string): { [key: string]: any } {
  if (!query) {
    return {}
  }

  return query
    .replace(/^\?/, '')
    .split('&')
    .reduce((acc, criteria) => {
      const splitCriteria = criteria.split('=')
      let k = splitCriteria[0]
      const v = splitCriteria[1]

      if (/\[\]$/.test(k)) {
        k = k.replace('[]', '')
        acc[k] = acc[k] || []
        acc[k].push(v)
      } else {
        acc[k] = v || ''
      }

      return acc
    }, {})
}

export function formatQueryString(query: object): string {
  return Object.keys(query)
    .map((k) => {
      return Array.isArray(query[k])
        ? (query[k] as string[]).map((v) => `${k}[]=${v}`).join('&')
        : `${k}=${query[k]}`
    })
    .join('&')
}
